var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8998 14.4007V9.12669C14.8998 6.53469 14.3418 4.55469 11.3178 4.55469C9.85975 4.55469 8.88775 5.34669 8.49175 6.10269H8.45575V4.78869H5.59375V14.4007H8.58175V9.63069C8.58175 8.37069 8.81575 7.16469 10.3638 7.16469C11.8938 7.16469 11.9118 8.58669 11.9118 9.70269V14.3827H14.8998V14.4007Z",
    fill: "url(#paint0_linear_4_771)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.734375 4.78906H3.72238V14.4011H0.734375V4.78906Z",
    fill: "url(#paint1_linear_4_771)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.228 0C1.274 0 0.5 0.774002 0.5 1.728C0.5 2.68201 1.274 3.47401 2.228 3.47401C3.18201 3.47401 3.95601 2.68201 3.95601 1.728C3.95601 0.774002 3.18201 0 2.228 0V0Z",
    fill: "url(#paint2_linear_4_771)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_771",
    x1: 5.59375,
    y1: 9.51771,
    x2: 14.8998,
    y2: 9.51771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_771",
    x1: 0.734375,
    y1: 9.63414,
    x2: 3.72238,
    y2: 9.63414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_771",
    x1: 0.5,
    y1: 1.75113,
    x2: 3.95601,
    y2: 1.75113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.adc0aef75a4a14029ce0f5851e8713e0.svg";
export { ForwardRef as ReactComponent };